import { api, apiweb } from "../ajax";
// import registerWebPush from "../webPushNotifications";
import Vue from "vue";
import { vue } from "../main";

function validateEmail(email) {
	const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	return re.test(String(email).toLowerCase());
}

function hasNonDigitalProducts(cart) {
	return cart.products.some((item) => item.digital === 0);
}

function isMixedCart(cart) {
	return (
		cart.products.some((item) => item.digital === 0) &&
		cart.products.some((item) => item.digital === 1)
	);
}

function getStyles() {
	const styles = localStorage.getItem("styles");
	if (styles) {
		return JSON.parse(styles);
	}
	return {
		"--primary-color": "#FBEB45",
		"--secondary-color": "#22214A",
		"--chat-bubble-color": "#FCEA85",
		"--app-button": "#22214A",
		"--app-button-text": "#fff",
		"--secondary-app-button": "#22214A",
		"--chat-bg": "transparent",
		"--main-bg": "#FFFFFF",
		"--main-bg-details": "#FFFFFF",
	};
}

export default {
	namespaced: true,
	state: {
		messages: [],
		payment_messages: [],
		address_messages: [],
		structure: { name: "", image: "", phone: "" },
		request: false,
		progress: 0,
		categories: [],
		prevStatus: "",
		status: "",
		products: [],
		product: null,
		extras: null,
		faqs: [],
		cart: { email: null, products: [], extras: [] },
		bill: [],
		banks: [],
		bank: {},
		file: null,
		whatsapp_message: "",
		user: null,
		network_error: {
			show: false,
			text: "Revisa tu coneccion a internet.",
		},
		add_to_cart_snackbar: {
			show: false,
			text: "Se ha agregado un producto a tu carrito.",
		},
		storeData: {},
		delivery: false,
		delivery_id: null,
		selectedDelivery: null,
		delivery_price: null,
		delivery_percent: null,
		updater: 0,
		client_coordinates: {},
		step: 1, //flag for get_address
		address_reference: "",
		uploading: false,
		uploadProgress: 0,
		styles: getStyles(),
		purchaseBill: null,
		loadingCart: false,
		subscriptionId: null,
	},
	mutations: {
		subscriptionId(state, id) {
			state.subscriptionId = id;
		},
		loadingCart(state, isLoading) {
			state.loadingCart = isLoading;
		},
		setPurchaseBill(state, bill) {
			state.purchaseBill = bill;
		},
		ADD_MESSAGE(state, msg) {
			if (state.status == "payment") {
				state.payment_messages.push(msg);
			}
			if (state.status == "get-address") {
				state.address_messages.push(msg);
			} else {
				state.messages.push(msg);
			}
		},
		STYLES(state, obj) {
			if (!obj) {
				return;
			}
			const newStyles = {
				"--primary-color": obj["primary-color"],
				"--secondary-color": obj["secondary-color"],
				"--chat-bubble-color": obj["chat-bubble-color"],
				"--app-button": obj["app-button"],
				"--app-button-text": obj["app-button-text"],
				"--secondary-app-button": obj["secondary-app-button"],
				"--chat-bg": obj["chat-bg"],
				"--main-bg": obj["main-bg"],
				"--main-bg-details": obj["main-bg-details"],
			};

			localStorage.setItem("styles", JSON.stringify(newStyles));

			state.styles = newStyles;
		},
		REQUEST(state, request) {
			state.request = request;
		},
		uploading(state, { uploading, progress }) {
			state.uploading = uploading;
			state.uploadProgress = progress;
		},
		STRUCTURE(state, structure) {
			state.structure = structure;
		},
		PROGRESS(state, value) {
			state.progress = value;
		},
		CATEGORIES(state, categories) {
			state.categories = categories;
		},
		PRODUCTS(state, products) {
			state.products = products;
		},
		PRODUCT(state, p) {
			state.product = p;
		},
		EXTRAS(state, extras) {
			state.extras = extras;
		},
		FAQS(state, faqs) {
			state.faqs = faqs;
		},
		ADD_CART(state, { data, key }) {
			state.cart[key].push(data);
		},
		UPDATE_CART(state, { item, index }) {
			if (item.type === "extras") {
				index = index - state.cart.products.length;
			}
			let arr = state.cart[item.type];
			arr.splice(index, 1);

			Vue.set(state.cart, item.type, arr);
		},
		BANKS(state, banks) {
			state.banks = banks;
		},
		BANK_SELECTED(state, bank) {
			state.bank = bank;
		},
		UPLOAD_FILE(state, file) {
			state.file = file;
		},
		STATUS(state, status) {
			if (status == state.status) {
				return;
			}
			state.updater = Math.floor(Math.random() * 199990);
			if (status == "choose-delivery") {
				if (!hasNonDigitalProducts(state.cart)) {
					state.prevStatus = state.status;
					state.status = "banks";
					state.digitalPurchase = true;
					return;
				}
			}
			state.prevStatus = state.status;

			if (status === "check-email" && state.user) {
				state.status = "cart";
				return;
			}

			state.status = status;
		},
		SET_CART_AND_USER(state, { cart, user }) {
			state.cart = cart;
			state.user = user;
		},
		SET_BILL(state, bill) {
			state.bill = bill;
		},
		SHOW_CONNECTION_ERROR(state) {
			state.network_error = {
				...state.network_error,
				show: true,
			};
		},
		SET_DELIVERY(state, payload = null) {
			state.delivery = false;
			state.delivery_price = null;
			state.delivery_percent = null;
			if (payload) {
				state.delivery = true;
				state.delivery_id = payload.company_id;
				state.selectedDelivery = payload;
				state.delivery_price = payload.delivery.price;
				state.delivery_percent = payload.delivery.percent;
				state.address_reference = "";
				state.address_messages = [];
			}
		},
		SET_CLIENT_LOCATION(state, { lat, lng }) {
			state.client_coordinates = {
				latitude: lat,
				longitude: lng,
			};
			state.step = 1;
			state.address_reference = "";
			state.address_messages = [];
		},
		UPDATER(state) {
			state.updater = Math.floor(Math.random() * 199990);
		},
		SHOW_ADD_TO_CART_SNACKBAR(state, data) {
			state.add_to_cart_snackbar = {
				show: true,
				text: `Se ha agregado ${data.name} al carrito`,
			};
		},
		snackbar(state, data) {
			state.add_to_cart_snackbar = {
				show: true,
				text: data,
			};
		},
	},
	actions: {
		/**
		 * Realiza una consulta directa a la api
		 * y extrae los datos de la tienda
		 * para el marco del chat
		 */
		init({ commit, state }, data) {
			commit("REQUEST", true);
			return new Promise((resolve, reject) => {
				const hasProduct = !!data.product;
				const url = hasProduct
					? `/web-store/get_product/${data.id}/${data.product}`
					: `/store/${data.id}`;
				api
					.get(url)
					.then((response) => {
						if( hasProduct && response.data === 404) {
							location.href = `/${data.id}`
						}
						const rdata = hasProduct ? response.data.store : response.data;
						const structure = {
							name: rdata.name,
							image: rdata.image,
							phone: rdata.phone,
						};
						state.storeData = rdata;
						document.title = rdata.name || "Tu tienda botones";
						commit("STYLES", rdata.templates[0]);
						commit("STRUCTURE", structure);
						if (hasProduct) {
							const p = {
								messages: [
									{
										actions: [],
										additionalParameters: response.data.product,
										callback_id: null,
										fallback: null,
										text: "Tenemos este producto para ti",
									},
								],
								status: 200,
							};
							commit("PRODUCT", p);
							commit("STATUS", "product");
						}
						commit("REQUEST", false);
						resolve(response.data);
					})
					.catch((error) => {
						if (error.message == "Network Error") {
							commit("SHOW_CONNECTION_ERROR");
						}
						commit("REQUEST", false);
						reject(error.response);
					});
			});
		},
		/**
		 * Inicializa el chat con el bot
		 */
		inital_bot_message({ commit }, data) {
			commit("REQUEST", true);
			return new Promise((resolve, reject) => {
				apiweb
					.post("/web-store/" + data.id, data.data)
					.then((response) => {
						commit("REQUEST", false);
						commit("PROGRESS", 10);
						resolve(response.data);
					})
					.catch((error) => {
						if (error.message == "Network Error") {
							commit("SHOW_CONNECTION_ERROR");
						}
						commit("REQUEST", false);
						reject(error.response);
					});
			});
		},
		show_catalogue({ commit }, data) {
			commit("REQUEST", true);
			// if (!state.user) {
			// commit("STATUS", "check-email");
			// commit("REQUEST", false);
			// } else {
			return new Promise((resolve, reject) => {
				apiweb
					.post("/web-store/" + data.id, data.data)
					.then((response) => {
						commit("REQUEST", false);
						commit("PROGRESS", 15);
						commit("CATEGORIES", response.data.messages);
						commit("STATUS", "catalogue");
						resolve(response);
					})
					.catch((error) => {
						if (error.message == "Network Error") {
							commit("SHOW_CONNECTION_ERROR");
						}
						commit("REQUEST", false);
						reject(error);
					});
			});
			// }
		},
		show_products({ commit }, data) {
			commit("REQUEST", true);
			return new Promise((resolve, reject) => {
				apiweb
					.post("/web-store/" + data.id, data.data)
					.then((response) => {
						commit("REQUEST", false);
						commit("PROGRESS", 20);
						commit("STATUS", "products");
						commit("PRODUCTS", response.data);
						resolve(response.data);
					})
					.catch((error) => {
						if (error.message == "Network Error") {
							commit("SHOW_CONNECTION_ERROR");
						}
						commit("REQUEST", false);
						reject(error);
					});
			});
		},
		get_product_details({ commit }, data) {
			commit("REQUEST", true);
			return new Promise((resolve, reject) => {
				apiweb
					.post("/web-store/" + data.id, data.data)
					.then((response) => {
						commit("REQUEST", false);
						commit("PROGRESS", 20);
						commit("STATUS", "product");
						commit("PRODUCT", response.data);
						resolve(response.data);
					})
					.catch((error) => {
						if (error.message == "Network Error") {
							commit("SHOW_CONNECTION_ERROR");
						}
						commit("REQUEST", false);
						reject(error);
					});
			});
		},
		get_extras({ commit, dispatch }, data) {
			commit("REQUEST", true);
			return new Promise((resolve, reject) => {
				api
					.get("/catalogues/" + data.id + "/extras")
					.then((response) => {
						commit("REQUEST", false);
						commit("PROGRESS", 30);
						if (response.status === 204) {
							if (data.pushToCart) {
								dispatch("setStatusToShowCart");
							} else {
								commit("STATUS", "catalogue");
							}
						} else {
							commit("STATUS", "extras");
						}
						commit("EXTRAS", response.data.data);
						resolve(response.data.data);
					})
					.catch((error) => {
						if (error.message == "Network Error") {
							commit("SHOW_CONNECTION_ERROR");
						}
						commit("REQUEST", false);
						reject(error);
					});
			});
		},
		get_faqs({ commit, state }) {
			commit("REQUEST", true);
			return new Promise((resolve, reject) => {
				// apiweb
				// 	.post("/web-store/" + data.id, data.data)
				api
					.get(`store/${state.storeData.id}/faqs`)
					.then((response) => {
						commit("REQUEST", false);
						commit("STATUS", "faqs");
						commit("FAQS", response.data);
						resolve(response.data);
					})
					.catch((error) => {
						if (error.message == "Network Error") {
							commit("SHOW_CONNECTION_ERROR");
						}
						commit("REQUEST", false);
						reject(error);
					});
			});
		},
		async add_to_cart({ commit }, { data, type }) {
			commit("REQUEST", true);
			commit("SHOW_ADD_TO_CART_SNACKBAR", data);
			if (type === "product") {
				commit("ADD_CART", { data, key: "products" });
				commit("REQUEST", false);
			}
			if (type === "extra") {
				commit("ADD_CART", { data, key: "extras" });
				commit("REQUEST", false);
			}
		},
		get_banks({ commit }, data) {
			commit("REQUEST", true);
			return new Promise((resolve, reject) => {
				apiweb
					.post("/web-store/" + data.id, data.data)
					.then((response) => {
						commit("REQUEST", false);
						commit("PROGRESS", 50);
						commit("BANKS", response.data.messages);
						resolve(response.data);
					})
					.catch((error) => {
						if (error.message == "Network Error") {
							commit("SHOW_CONNECTION_ERROR");
						}
						commit("REQUEST", false);
						reject(error);
					});
			});
		},
		get_prices_ves({ commit, state }, data) {
			commit("REQUEST", true);
			return new Promise((resolve, reject) => {
				api
					.post("/web-store/check_email", {
						email: state.user.email,
						store_id: data.id,
					})
					.then((response) => {
						commit("REQUEST", false);
						commit("PROGRESS", 70);
						resolve(response.data);
					})
					.catch((error) => {
						if (error.message == "Network Error") {
							commit("SHOW_CONNECTION_ERROR");
						}
						commit("REQUEST", false);
						reject(error);
					});
			});
		},
		user_send_file({ commit, state }, { file, id }) {
			if (state.status !== "payment") {
				return;
			}
			commit("REQUEST", true);
			const fileUrl = URL.createObjectURL(file);
			commit("uploading", { uploading: true, progress: 0 });
			let fd = new FormData();
			fd.append("image", file);
			fd.append("store", id);
			fd.append("email", state.user.email);
			fd.append("payment_method", state.bank.id);
			if (state.delivery) {
				if (state.delivery_id) {
					fd.append("delivery_id", state.delivery_id);
				}
				fd.append("delivery_price", state.delivery_price);
				fd.append("address_reference", state.address_reference);
				fd.append("client_coordinates", state.client_coordinates);
				fd.append("latitude", state.client_coordinates.latitude);
				fd.append("longitude", state.client_coordinates.longitude);
			}
			commit("ADD_MESSAGE", {
				author: "user",
				type: "file",
				file: fileUrl,
				uploading: true,
			});
			api
				.post("/web-store/check_out", fd, {
					onUploadProgress: (progressEvent) => {
						commit("uploading", {
							uploading: true,
							progress: Math.round(
								(progressEvent.loaded * 100) / progressEvent.total
							),
						});
					},
				})
				.then((res) => {
					if (res.data.message == "purchased") {
						commit("subscriptionId", state.user.id);
						// registerWebPush(res.data.data.id);
						commit("setPurchaseBill", res.data.bill);
						commit("uploading", {
							uploading: false,
							progress: 100,
						});
						commit("REQUEST", false);
						commit("SET_BILL", state.cart);
						commit("SET_CART_AND_USER", {
							cart: { ...state.cart, products: [], extras: [] },
							user: state.user,
						});
						commit("PROGRESS", 100);
						commit("ADD_MESSAGE", {
							author: "bot",
							type: "text",
							msg:
								"Perfecto, estamos por verificar tu comprobante de pago. Te enviaremos un correo con la información de tu compra.",
						});
						//aqui se inserta una imagen con la ubicacion fisica de la tienda
						// if (state.delivery == false) {
						// 	commit("ADD_MESSAGE", {
						// 		author: "bot",
						// 		type: "text",
						// 		showStoreLocation: !state.digitalPurchase,
						// 	});
						// }
						// commit("ADD_MESSAGE", {
						// 	author: "bot",
						// 	type: "text",
						// 	store: state.storeData,
						// });

						// fetch(`https://api.tubotones.com/invoice/${res.data.bill.code}`)
						// 	.then((r) => r.blob())
						// 	.then((blob) => {
						// 		var file = new File([blob], `${res.data.bill.code}jpg`, {
						// 			type: "image/jpeg",
						// 		});
						// 		var filesArray = [file];

						// 		var imageUrl = URL.createObjectURL(blob);

						// 		commit("ADD_MESSAGE", {
						// 			author: "bot",
						// 			type: "text",
						// 			download: true,
						// 			imageUrl,
						// 		});

						// 		if (
						// 			navigator.canShare &&
						// 			navigator.canShare({ files: filesArray })
						// 		) {
						// 			commit("ADD_MESSAGE", {
						// 				author: "bot",
						// 				type: "text",
						// 				shareable: true,
						// 				args: {
						// 					text: "some_text",
						// 					files: filesArray,
						// 					title: "some_title",
						// 					url: "some_url",
						// 				},
						// 			});
						// 		}
						// 	});

						// commit("ADD_MESSAGE", {
						// 	author: "bot",
						// 	type: "text",
						// 	invoice: true,
						// 	url: `https://api.tubotones.com/invoice/${res.data.bill.code}`,
						// });

						commit("ADD_MESSAGE", {
							author: "bot",
							type: "text",
							continueOnWA: true,
						});
					}
				});

			commit("UPLOAD_FILE", fileUrl);
		},
		setUserAndCart({ state, commit }, data) {
			commit("SET_CART_AND_USER", { cart: state.cart, user: data });
		},
		setStatusToShowCart({ commit, dispatch, state }) {
			if (state.user) {
				dispatch("syncCart", {
					email: state.user.email,
					products: state.cart.products,
					extras: state.cart.extras,
					store: vue.$route.params.id,
				});
			}
			commit("STATUS", "cart");
		},
		checkEmail({ commit, state, dispatch }, { fd, message, store }) {
			const msg = {
				author: "user",
				type: "text",
				msg: message,
			};
			commit("REQUEST", true);
			commit("ADD_MESSAGE", msg);
			if (validateEmail(message)) {
				api
					.post("/web-store/check_email", fd)
					.then(async (res) => {
						if (res.data.data == null) {
							commit("ADD_MESSAGE", {
								author: "bot",
								type: "text",
								msg: `Es tu primera vez comprando con nosotros. Queremos conocerte, por favor llena tus datos.`,
								newUser: true,
								email: message,
							});
							return;
						}

						let cart = {
							email: message,
							products: state.cart.products,
							extras: state.cart.extras,
							store,
						};

						let restoredCart = {
							email: message,
							products: res.data.cart ? [...res.data.cart] : null,
							extras: res.data.extras ? [...res.data.extras] : null,
							store,
						};

						// if (res.data.cart) {
						// 	cart.products = [...cart.products, ...res.data.cart];
						// }

						// if (res.data.extras) {
						// 	cart.extras = [...cart.extras, ...res.data.extras];
						// }

						// cart.extras = cart.extras.map((e) => ({ ...e, quantity: e.qtt }));
						if (restoredCart.products || restoredCart.extras) {
							commit("ADD_MESSAGE", {
								author: "bot",
								type: "text",
								cartRecovery: true,
								currentCart: cart,
								restoredCart: restoredCart,
							});
						} else {
							dispatch("syncCart", cart);
						}

						if (res.data.schedule && !res.data.schedule.open) {
							commit("ADD_MESSAGE", {
								author: "bot",
								type: "text",
								msg: res.data.schedule.message,
							});
							return;
						}
						commit("SET_CART_AND_USER", { cart: cart, user: res.data.data });

						// if (state.user) {
						// 	dispatch("setStatusToShowCart");
						// }
					})
					.catch((error) => {
						if (error.message == "Network Error") {
							commit("SHOW_CONNECTION_ERROR");
						}
					})
					.finally(() => {
						commit("REQUEST", false);
					});
			} else {
				commit("ADD_MESSAGE", {
					author: "bot",
					type: "text",
					msg:
						"Parece que el email que ingresaste no es válido. Por favor ingresa tu email de nuevo.",
				});
				commit("REQUEST", false);
			}
		},
		syncCart({ state, commit }, cart) {
			commit("loadingCart", true);
			api
				.post("web-store/add_to_cart", cart)
				.then(() => {
					Vue.set(state, "cart", cart);
				})
				.finally(() => {
					commit("loadingCart", false);
				});
			commit("STATUS", "cart");
		},
		delete_cart_item({ commit, state }, { pid, type, name }) {
			commit("REQUEST", true);
			if (state.user) {
				if (type === "products") {
					api.post("/web-store/remove_from_cart", {
						email: state.user.email,
						pid,
					});
				}
				if (type === "extras") {
					api.post("/web-store/remove_from_extra", {
						email: state.user.email,
						pid,
					});
				}
			}
			commit("snackbar", `Se ha eliminado ${name} del carrito`);
			commit("REQUEST", false);
		},
		user_send_message({ commit }, data) {
			const msg = {
				author: "user",
				type: "text",
				msg: data.raw,
			};
			commit("REQUEST", true);
			commit("ADD_MESSAGE", msg);
			commit("REQUEST", false);
			return new Promise((resolve, reject) => {
				apiweb
					.post("/web-store/" + data.id, data.data)
					.then((response) => {
						commit("REQUEST", false);
						commit("PROGRESS", 50);
						commit("STATUS", "payment");
						let bot_msg = response.data.messages[0];
						bot_msg["author"] = "bot";
						commit("ADD_MESSAGE", bot_msg);
						resolve(response.data);
					})
					.catch((error) => {
						if (error.message == "Network Error") {
							commit("SHOW_CONNECTION_ERROR");
						}
						commit("REQUEST", false);
						reject(error);
					});
			});
		},
		choose_delivery({ commit }) {
			commit("REQUEST", true);
			commit("STATUS", "choose-delivery");
			commit("REQUEST", false);
		},
		payment_process({ commit, state }) {
			commit("REQUEST", true);
			commit("STATUS", "payment");

			if (!hasNonDigitalProducts(state.cart)) {
				commit("ADD_MESSAGE", {
					author: "bot",
					type: "text",
					msg: `Tu compra sera enviada a <b>${state.user.email}</b>`,
				});
			}
			if (isMixedCart(state.cart)) {
				commit("ADD_MESSAGE", {
					author: "bot",
					type: "text",
					msg: `Los productos digitales en tu compra seran enviados a <b>${state.user.email}</b>`,
				});
			}
			commit("ADD_MESSAGE", {
				author: "bot",
				type: "text",
				msg:
					"Por favor adjunta imagen del pago 📎 para proceder con la compra 🛒.",
				showAddFileButton: true,
			});

			commit("REQUEST", false);
			//the payment process continues after the user inputs an image, in user_send_file()
		},
		delivery_payment_process({ commit }, payload) {
			commit("SET_DELIVERY", payload);
			commit("STATUS", "get-address");
		},
		get_client_location({ commit, dispatch }, payload = null) {
			commit("SET_CLIENT_LOCATION", payload);
			dispatch("get_address");
		},
		get_address({ commit, state }, payload = null) {
			if (payload) {
				state.step = state.step + 1;
				state.address_reference += payload;
				if (state.step <= 3) {
					state.address_reference += ";";
				}

				commit("ADD_MESSAGE", {
					author: "user",
					type: "text",
					msg: payload,
				});
			}

			let msg = {
				1: "Por favor indique el nombre de la calle de su residencia:",
				2: "Por favor indique el nombre de su residencia o número de casa:",
				3: "Por favor indique un teléfono de contacto:",
			}[state.step];

			commit("ADD_MESSAGE", {
				author: "bot",
				type: "text",
				msg,
			});

			if (state.step > 3) {
				commit("STATUS", "banks");
			}
		},
	},
	getters: {
		get_request: (state) => {
			return state.request;
		},
		get_structure: (state) => {
			return state.structure;
		},
		get_messages: (state) => {
			return state.messages;
		},
		get_payment_messages: (state) => {
			return state.payment_messages;
		},
		get_address_messages: (state) => {
			return state.address_messages;
		},
		get_progress: (state) => {
			return state.progress;
		},
		get_categories: (state) => {
			return state.categories;
		},
		get_status: (state) => {
			return state.status;
		},
		get_products: (state) => {
			return state.products;
		},
		get_product: (state) => {
			return state.product;
		},
		get_extras: (state) => {
			return state.extras;
		},
		get_faqs: (state) => {
			return state.faqs;
		},
		get_cart: (state) => {
			return state.cart;
		},
		get_bill: (state) => {
			return state.bill;
		},
		get_banks: (state) => {
			let deliveryBanks =
				state.storeData.deliveries_companies &&
				state.storeData.deliveries_companies
					.filter((i) => i !== null)
					.filter((c) => c.id === state.delivery_id)[0] &&
				state.storeData.deliveries_companies
					.filter((i) => i !== null)
					.filter((c) => c.id === state.delivery_id)[0].banks;
			if (deliveryBanks) {
				return [
					{
						text: "La empresa de delivery tiene las siguientes opciones:",
						additionalParameters: deliveryBanks,
					},
				];
			}
			return state.banks;
		},
		get_bank: (state) => {
			return state.bank;
		},
		get_file: (state) => {
			return state.file;
		},
		get_whatsapp_message: (state) => {
			return state.whatsapp_message;
		},
		get_network_error: (state) => state.network_error,
		get_add_to_cart_snackbar: (state) => state.add_to_cart_snackbar,
		get_store_data: (state) => state.storeData,
		updater: (state) => state.updater,
		get_delivery_price: (state) => ({
			price: state.delivery_price,
			percent: state.delivery_percent,
			dollar_rate: state.storeData.dollar_rate,
		}),
		get_delivery_data: (state) => ({
			delivery: state.delivery,
			companies: state.storeData.deliveries_companies,
			delivery_id: state.delivery_id,
			price: state.delivery_price,
			percent: state.delivery_percent,
			dollar_rate: state.storeData.dollar_rate,
		}),
		get_uploading: (state) => ({
			uploading: state.uploading,
			uploadProgress: state.uploadProgress,
		}),
		getAppStyles: (state) => {
			return state.styles;
		},
		get_user: (state) => state.user,
		getPurchaseBill: (state) => state.purchaseBill,
		loadingCart: (state) => state.loadingCart,
		subscriptionId: (state) => state.subscriptionId,
	},
};
